import React, { useEffect, useState } from 'react'
import { DateCon, HeadActions, HubTitle, MatchActions, TeamInfo } from './styles'
import { Box } from '../../Components/Layout'
import { PLL_LINKS } from '../../Config/config'
import { STATS_YEAR } from '../../Config/League/league.config'
import { MatchupList } from './weekSwiper/MatchupList'
import { getTeamIc, timeStampToDate, logEvent } from '../../Utils'
import { createShopUTM } from '../../Routing'
import type { EventGQL } from '../../Api'
import { Media } from './media/Media'
import { Con } from '../../Components/Layout/Containers/ConStyles'
import { colors } from '../../Components/consts'
import { Desc } from '../../Components/Typography/Text.styles'
import { Lk } from '../../Components/Links/Lk'
type MatchupProps = {
  events: EventGQL[]
}

export const MatchupSlider: React.FC<React.PropsWithChildren<MatchupProps>> = ({
  events,
}) => {
  const [selectedEvent, setSelectedEvent] = useState<EventGQL | null>(events[0])

  useEffect(() => {
    if (!events) {
      return
    } else {
      getStartingEvent(events)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events])

  const handleEventChange = (event: EventGQL) => {
    setSelectedEvent(event)
  }

  const getStartingEvent = (events: EventGQL[]) => {
    const ev = events.find((e) => e.eventStatus < 2)
    if (!events) return
    setSelectedEvent(ev!)
  }

  const findEventIndex = (event: EventGQL) => {
    const idx = events.findIndex((ev) => ev.slugname === event.slugname)
    return idx === -1 ? '0' : `${idx}`
  }

  const renderDateTime = (event: EventGQL) => {
    const obj = timeStampToDate(event.startTime)
    return (
      <DateCon>
        <h2>{obj.date}</h2>
        <p>{obj.time}</p>
      </DateCon>
    )
  }

  return (
    <>
      {selectedEvent && (
        <>
          <MatchupList
            eventList={events}
            activeEvent={selectedEvent}
            idx={findEventIndex(selectedEvent)}
            handleEventChange={handleEventChange}
          />
        </>
      )}
      <Box padding={0} boxColor={colors.darkBackground}>
        {selectedEvent && selectedEvent.seasonSegment !== 'champseries' && selectedEvent.slugname.includes('championship') && (
          <DateCon>
            <h2>{'CHAMPIONSHIP'}</h2>
          </DateCon>
        )}

        {selectedEvent && selectedEvent.seasonSegment === 'champseries' && (
          <DateCon>
            <h2>{'CHAMPIONSHIP SERIES'}</h2>
          </DateCon>
        )}
        {selectedEvent && <div>{renderDateTime(selectedEvent)}</div>}
        {selectedEvent && (
          <>
            <Con direction='row' justify='space-around' noMargin noPadding>
              <Con direction='column' noMargin noPadding>
                <TeamInfo>
                  {selectedEvent.awayTeam?.fullName ? (
                    <>
                      <img
                        src={getTeamIc(selectedEvent.awayTeam.fullName)}
                        alt=""
                      />
                      <h2>{selectedEvent.awayTeam.fullName}</h2>
                      <p>{`${selectedEvent.awayTeam.teamWins}-${selectedEvent.awayTeam.teamLosses}`}</p>
                    </>
                  ) : (
                    <h2>TBD</h2>
                  )}
                </TeamInfo>
              </Con>
              <Con direction='column' justify='flex-end' noMargin noPadding>
                <TeamInfo>
                  {selectedEvent.homeTeam?.fullName ? (
                    <>
                      <img
                        src={getTeamIc(selectedEvent.homeTeam.fullName)}
                        alt=""
                      />
                      <h2>{selectedEvent.homeTeam.fullName}</h2>
                      <p>{`${selectedEvent.homeTeam.teamWins}-${selectedEvent.homeTeam.teamLosses}`}</p>
                    </>
                  ) : (
                    <h2>TBD</h2>
                  )}
                </TeamInfo>
              </Con>
            </Con>
          </>
        )}
      </Box>

      <Box boxColor={colors.darkBackground} sideMargins={0}>
        <Con direction='column' justify='center' align='center' noMargin noPadding>
          {selectedEvent?.eventStatus === 1 && (
            <>
              <HubTitle>Follow the live stats during the game</HubTitle>
              <Lk
                link={`${PLL_LINKS.stats}/games/${selectedEvent.year || STATS_YEAR}/${
                  selectedEvent?.slugname
                }`}
                alt="Live Stats"
              >
                <HeadActions
                  onClick={() =>
                    logEvent('live_stats_click', {
                      section: 'Event Hub',
                      game: selectedEvent.slugname,
                    })
                  }
                >
                  Live Stats
                </HeadActions>
              </Lk>
            </>
          )}
          {selectedEvent?.seasonSegment === 'allstar' && (
            <>
              <HubTitle>
                {' '}
                Get all your All Star Game analysis, rosters, and more.
              </HubTitle>
              <Con direction='row' justify='center' align='center' noMargin noPadding>
                <Lk link={PLL_LINKS.allstar} alt='All Star Hub'>
                  <MatchActions
                    onClick={() =>
                      logEvent('all_star_analysis_click', {
                        section: 'Event Hub',
                        game: selectedEvent.slugname,
                      })
                    }
                  >
                    All Star Hub
                  </MatchActions>
                </Lk>
                <Lk link={PLL_LINKS.allstar} alt='Rosters'>
                  <MatchActions
                    onClick={() =>
                      logEvent('all_star_rosters_click', {
                        section: 'Event Hub',
                        game: selectedEvent.slugname,
                      })
                    }
                  >
                    Rosters
                  </MatchActions>
                </Lk>
              </Con>
  
            </>
          )}
          {selectedEvent && selectedEvent.seasonSegment !== 'allstar' && (
            <>
              <HubTitle> Gameday Prep </HubTitle>
              <Con direction='column' justify='center' align='center' noMargin noPadding>
                <Lk link={`${PLL_LINKS.matchup}/${selectedEvent?.slugname}`} alt='Matchup Analysis'>
                  <MatchActions
                    onClick={() =>
                      logEvent('matchup_analysis_click', {
                        section: 'Event Hub',
                        game: selectedEvent.slugname,
                      })
                    }
                  >
                    Matchup Analysis
                  </MatchActions>
                </Lk>
                <Lk link={`${PLL_LINKS.matchup}/${selectedEvent?.slugname}?tab=roster`} alt='Team Rosters'>
                  <MatchActions
                    onClick={() =>
                      logEvent('team_rosters_click', {
                        section: 'Event Hub',
                        game: selectedEvent.slugname,
                      })
                    }
                  >
                    Team Rosters
                  </MatchActions>
                </Lk>
              </Con>

            </>
          )}
          {selectedEvent?.slugname && <Media tag={selectedEvent.slugname} />}
          <HubTitle>PLL Top Shelf</HubTitle>
          <Desc textColor={colors.gray.gray40}>Play PLL's first mobile game</Desc>
          <Lk link={'https://premierlacrossleague.com/pll-top-shelf'} alt='Play Now' role='button'>
            <HeadActions
              onClick={() =>
                logEvent('top_shelf_click', {
                  section: 'Event Hub',
                })
              }
            >
              Play Now
            </HeadActions>
          </Lk>

          <HubTitle> Useful Links </HubTitle>
          <Lk
            link={createShopUTM({
              medium: `Event Hub`,
              slug: '',
              campaign: 'PLL_Shop_Button',
            })}
            alt="PLL Shop"
            role="button"
          >
            <HeadActions
              onClick={() =>
                logEvent('shop_click', {
                  section: 'Event Hub',
                })
              }
            >
              PLL Shop
            </HeadActions>
          </Lk>
        </Con>
      </Box>
    </>
  )
}
